var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRecordCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-5.93 4.83-10.75 10.75-10.75S22.72 6.07 22.72 12 17.9 22.75 11.97 22.75C6.05 22.75 1.22 17.93 1.22 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25S2.72 6.9 2.72 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02 12a4.98 4.98 0 1 1 9.96.001A4.98 4.98 0 0 1 7.02 12zm1.5 0c0 1.92 1.56 3.48 3.48 3.48s3.48-1.56 3.48-3.48S13.92 8.52 12 8.52 8.52 10.08 8.52 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRecordCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-record-circle.b521113082c52653702a9d1663490caf.svg";
export { ForwardRef as ReactComponent };